"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchData = fetchData;
exports.usePickupSearchConfigurationQuery = void 0;
var _fetching = require("@ori/fetching");
var _swrConfig = require("../constants/swrConfig");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _utils = require("../utils");
const hookName = 'usePickupSearchConfigurationQuery';
const dataUrl = '/system/ajax/DeliverySelection/GetPickupSearchConfiguration';
const catchError = async promise => (0, _utils.catchPromiseError)(promise, `Error in ${hookName} hook`);
const transformData = data => {
  (0, _logger.logDebug)(`${hookName} hook transformData(): data before transformation:\n\t`, data);
  const {
    isInstantResultShown: isListInstantResultEnabled,
    ...rest
  } = data;
  const result = {
    ...rest,
    isListInstantResultEnabled
  };
  (0, _logger.logInfo)(`${hookName} hook: loaded data after transformation:\n\t`, result);
  return result;
};
async function fetchData(options) {
  (0, _logger.logInfo)(`${hookName} hook: Loading data ...`);
  const promise = catchError((0, _utils.getUrl)(options));
  const data = await promise;
  return transformData(data);
}
const usePickupSearchConfigurationQuery = () => {
  const {
    cacheKeys,
    urlOptions
  } = (0, _hooks.useUrlOptions)(dataUrl);
  const fetcher = async () => fetchData(urlOptions);
  (0, _logger.logDebug)(`${hookName} hook called.\n\turlOptions:`, urlOptions);
  const {
    data: pickupSearchConfiguration,
    error: configurationError,
    isValidating: isConfigurationLoading
  } = (0, _fetching.useSWR)(cacheKeys, fetcher, _swrConfig.errorHandlingSwrOptions);
  return {
    configurationError,
    isConfigurationLoading,
    pickupSearchConfiguration
  };
};
exports.usePickupSearchConfigurationQuery = usePickupSearchConfigurationQuery;